import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./authSlice";
import dashboardSlice from "./dashboardSlice";
import fieldSlice from "./fieldSlice";
import supertrackSlice from "./supertrackSlice";
import communicationSlice from "./communicationSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    dashboard: dashboardSlice,
    field: fieldSlice,
    superTracks: supertrackSlice,
    communication: communicationSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

window.__store = store;

export default store;
